import {
    FETCH_CUSTOM_PRICING_TEMPLATES_PENDING,
    FETCH_CUSTOM_PRICING_TEMPLATES_SUCCESS,
    FETCH_CUSTOM_PRICING_TEMPLATES_FAILED,
    FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_PENDING,
    FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_SUCCESS,
    FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_FAILED,
    DELETE_CUSTOM_PRICING_TEMPLATE_SUCCESS,
} from '../constants/customPricingTemplate.constant';

const initialState = {
    templateList: [],
    templateListStatus: 'IDLE',
    totalRecords: 0,
    currentTemplate: null,
    currentTemplateStatus: 'IDLE',
};

const mapTemplateItem = (item = {}) => ({
    ...item,
    id: item.id || item.customPricingTemplateId || 0,
    templateName: item.templateName || '',
    warehouseName: item.warehouseNames || item.warehouseName || '',
    companyName: item.companyNames || item.companyName || '',
    sellerName: item.sellerNames || item.sellerName || '',
    serviceType: item.serviceTypeName || item.serviceType || '',
    subServiceType: item.subServiceTypeNames || item.subServiceType || item.subServiceTypeName || '',
    skuIds: item.skuIds || item.skuId || '',
    carrierConnectNumbers: item.carrierConnectNumbers || '',
});

const getTemplateListFromResponse = (payload = {}) => {
    const list = payload?.EntityList || payload?.Entity?.customTemplates || [];
    return Array.isArray(list) ? list.map(mapTemplateItem) : [];
};

const getTotalRecordsFromResponse = (payload = {}) => {
    const total = payload?.TotalRecords ?? payload?.Entity?.totalRecords ?? 0;
    return Number.isFinite(total) ? total : 0;
};

const customPricingTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CUSTOM_PRICING_TEMPLATES_PENDING:
            return { ...state, templateListStatus: 'PENDING' };
        case FETCH_CUSTOM_PRICING_TEMPLATES_SUCCESS:
            return {
                ...state,
                templateListStatus: 'SUCCESS',
                templateList: getTemplateListFromResponse(action.payload),
                totalRecords: getTotalRecordsFromResponse(action.payload),
            };
        case FETCH_CUSTOM_PRICING_TEMPLATES_FAILED:
            return { ...state, templateListStatus: 'FAILED', templateList: [] };
        case FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_PENDING:
            return { ...state, currentTemplateStatus: 'PENDING' };
        case FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_SUCCESS:
            return { ...state, currentTemplateStatus: 'SUCCESS', currentTemplate: action.payload };
        case FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_FAILED:
            return { ...state, currentTemplateStatus: 'FAILED', currentTemplate: null };
        case DELETE_CUSTOM_PRICING_TEMPLATE_SUCCESS:
            return {
                ...state,
                templateList: state.templateList.filter(t => t.id !== action.payload),
                totalRecords: state.totalRecords > 0 ? state.totalRecords - 1 : 0,
            };
        default:
            return state;
    }
};

export default customPricingTemplateReducer;
